export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/payout/connected-payment-account', 'service-provider.connected-payment-account')
    .when('/service-provider/payout/transactions', 'service-provider.transactions')
    .when('/service-provider/payout/transactions/:id', 'service-provider.transaction-info')

    .within('service-provider')

    .segment('connected-payment-account', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.payout'
      }],
      template: '<service-provider-connected-payment-account-page></service-provider-connected-payment-account-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-connected-payment-account.module" */ "./connected-payment-account/service-provider-connected-payment-account.module");
      }
    })

    .segment('transactions', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.payout'
      }],
      template: '<service-provider-transactions-page></service-provider-transactions-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-transactions.module" */ "./transactions/service-provider-transactions.module");
      }
    })

    .segment('transaction-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.payout',
          url: '/service-provider/payout/transactions'
        },
        {
          label: 'service_provider.breadcrumb.payout_details'
        }
      ],
      template: '<service-provider-transaction-info-page></service-provider-transaction-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-transaction-info.module" */ "./transaction-info/service-provider-transaction-info.module");
      }
    });
}
